import { observable, runInAction, action } from "mobx";
import OrderListApi from "../api/OrderListApi";
import { autobind } from "core-decorators";
import { tools, Modal, Toast } from 'tplus-voucher';
import { history } from "mutants-microfx";

class OrderListModel {

    searchType = 0;//搜索类型
    stateType = 0;//状态类型
    dateRange = 7;//时间类型
    keyWord = '';//搜索条件
    BeginDate = '';
    EndDate = '';
    IsAssocion = false;
    ID = '';
    PageIndex = 1;
    PageSize = '16';
    KeyWord = '';
    IsChooseVoucher = false;
    IdPartner = '';


    bottomAction = '';

    @observable progressState = 'show';
    @observable data = {};//后台返回数据
    @observable totalAmount = [];
    @observable lists = [];

    constructor() {
    }


    init() {
        this.searchType = 0;//搜索类型
        this.stateType = 0;//状态类型
        this.dateRange = 0;//时间类型
        this.keyWord = '';//搜索条件
        this.data = {};
        this.lists = [];
    }

    //请求列表
    @action async loadData(type) {
        this.progressState = 'load'
        let Param = {
            "BeginDate": this.BeginDate,
            "IsAssocion": this.IsAssocion,
            "ID": this.ID,
            "DateRange": this.dateRange,
            "SearchType": this.searchType,
            "PageIndex": this.PageIndex,
            "KeyWord": this.keyWord,
            "ApproveState": this.stateType,
            "EndDate": this.EndDate,
            "IsChooseVoucher": false,
            "PageSize": this.PageSize,
            "IdPartner": this.IdPartner
        };
        try {
            let orderList = await OrderListApi.getOrderList(Param);
            runInAction(type, () => {
                this.progressState = 'show'
                this.hanleData(orderList, type);
            });
        } catch (error) {
            if (error.code) {
                setTip(true, 'error', error);
                console.log('err===' + JSON.stringify(error));
                this.progressState = 'error';
            }
        }


    }

    hanleData = (orderList, type) => {
        this.handleList(orderList, type);
        this.handleTotal(orderList);
    }
    handleList = (orderList, type) => {
        type == 'fresh' ? this.data = [] : '';
        let datas = [];
        for (let i = 0; i < orderList.SaleOrderList.length; i++) {
            let items = [];
            let item = orderList.SaleOrderList[i];
            items.push({ 'title': item.VoucherCode, 'style': {} });
            items.push({ 'title': item.VoucherState.Name, 'style': { 'color': item.VoucherState.ID == '181' ? 'red' : '#00bbd2' } });
            items.push({ 'title': item.Customer.Name, 'style': { 'fontSize': '0.14rem', 'fontWeight': 'bold' } });
            items.push({ 'title': item.TotalAmount, 'style': { 'fontWeight': 'bold' } });
            items.push({ 'title': '业务员:' + item.LinkMan, 'style': {} });
            items.push({ 'title': item.VoucherDate, 'style': {} });
            item.showItems = items;
        }
        let list = orderList.SaleOrderList.map(item => {
            item.choose = false;
            item.canChoose = true;
            return observable(item);
        })
        if (this.PageIndex == 1) {
            this.data = orderList;
            this.lists = list
        } else {
            this.lists = this.lists.concat(list);
        }
    }

    handleTotal = (orderList) => {
        this.totalAmount = [];
        this.totalAmount.push({ 'title': '总单数', 'value': this.getTotalValueByName(orderList, 'TotalQuantity'), 'style': {} });
        this.totalAmount.push({ 'title': '合计', 'value': orderList.TotalAmount, 'style': { 'color': 'red' }, 'weight': { 'width': '100%' } });
        this.totalAmount.push({ title: '总收款', 'value': orderList.TotalSettleAmount, 'style': { 'color': 'red' } });
        this.totalAmount.push({ 'value': '共' + orderList.TotalQuantity + '种，' + orderList.TotalDetailQuantity + '件', 'style': { 'fontSize': '0.12rem' } });
    }


    search = (value) => {
        this.keyWord = value;
        this.loadData('fresh');
    }

    //过滤条件带入
    filter = (data) => {
        //重新加载数据
        this.searchType = data.searchType[0].value;
        this.dateRange = data.dateRange[0].value;
        if (data.stateType.length == 1) {
            this.stateType = data.stateType[0].value;
        } else {
            this.stateType = 7;
            this.BeginDate = '';
            this.EndDate = '';
        }
        this.loadData('fresh');
    }

    onItemClick = (rowID) => {
        let data = this.lists[rowID];
        history.push(`/SO/SA04/${data.ID}?pid=voucherdetail`);
    }

    itemActionClick = (rowID, openChoose) => {
        return openChoose ? this.choose(rowID) : this.getActionButtons(rowID);
    }

    choose = (rowID) => {
        let data = this.lists[rowID];
        data.choose = !data.choose;
        for (const item in this.lists) {
            if (this.lists.hasOwnProperty(item)) {
                if (item.Customer.CustomerID != data.Customer.CustomerID)
                    item.canChoose = false;
            }
        }
    }

    getActionButtons = (index) => {
        let item = this.lists[index];
        const sysInfos = tools.getLocalCache('SysInfo');
        let actionButtons = [];
        if (sysInfos.SaleOrderFieldAuth.IsAdd) {
            let add = { type: 'add', 'title': '复制' };
            actionButtons.push(add);
        }
        if (item.IsDelete && item.VoucherState.Name != '中止') {
            let del = { type: 'delete', 'title': '删除' };
            actionButtons.push(del);
        }
        if (1) {
            let print = { type: 'print', 'title': '打印' };
            actionButtons.push(print);
            let cancle = { type: 'cancle', 'title': '取消' };
            actionButtons.push(cancle);
        }
        return actionButtons;
    }

    //列表更多按钮事件
    onActionSheet = (item, rowID) => {
        if (item.type == 'add') {
            this.add(rowID);
        } else if (item.type == 'delete') {
            this.delete(rowID);
        } else if (item.type == 'print') {
            this.print(rowID);
        }
    }
    //复制
    add = (rowID) => {
        let item = this.lists[rowID];
        history.push(`/SO/SA03/${item.ID}`, { 'operateAction': 'copy', fromPage: 'list' });
    }
    //删除
    delete = (rowID) => {
        Modal.alert('温馨提示', '您确认删除此单据？', [

            {
                text: '取消',
                onPress: () => {
                }
            },
            {
                text: '确定',
                onPress: () => {
                    this.deleteSaleOrder(rowID);
                }
            }
        ])
    }
    deleteSaleOrder = async (rowID) => {
        let item = this.lists[rowID];
        let result = await OrderListApi.deleteSaleOrder({ 'ID': item.ID, 'Ts': item.Ts });
        //刷新页面
        Toast.info('删除成功！', 2);
        this.loadData('fresh');
    }

    //打印 小票打印=》跳转打印预览  云打印=》直接打印
    print = (rowID) => {

    }


    bottomBtnClick = (item) => {
        //page页面底部按钮变为确定
        this.bottomAction = item.chooseBox ? item.action : this.bottomAction;
        this[item.action](item);

    }
    //生单按钮事件
    circulationAction = (item) => {
        //IsChooseVoucher:true 
        this.IsChooseVoucher = true;
        this.loadData('fresh');
    }

    //底部确定事件
    sure = () => {
        if (this.bottomAction = 'circulationAction') {
            //生单
            this.circulation();
        }
        this.bottomAction = '';
    }

    //生单
    @action async circulation(type) {
        this.IsChooseVoucher = false;
        //生单接口 获取数据保存本地 并跳转新增页面
        let ids = this.lists.map((item) => {
            if (item.choose) {
                return item.ID;
            }
        })
        let Param = { 'FromVoucherType': 'SA03', 'IdinvoiceType': '203', 'VoucherIds': ids, 'NameinvoiceType': '收据', 'ToVoucherType': 'SA04' };
        let saleDelivery = await OrderListApi.circulationSaleDeliveryInfo(Param);
        let date = new Date().getTime();
        tools.setLocalCache(date, JSON.stringify(saleDelivery));
        history.push(`/SA/SA04/${date}`, { 'operateAction': 'birth', fromPage: 'list' });
    }



}
export default OrderListModel;